import React, { useState } from "react";
import "assets/css/faq-section.css";

const FaqSection = ({ questions, title }) => {
  const [openIndex, setOpenIndex] = useState(0);

  const half = Math.ceil(questions.length / 2);
  const leftQuestions = questions.slice(0, half);
  const rightQuestions = questions.slice(half);

  const toggleQuestion = (index) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };

  const renderItem = (item, index) => {
    const isOpen = openIndex === index;
    return (
      <div
        key={index}
        className={`faq-card ${isOpen ? "faq-card--open" : ""}`}
        onClick={() => toggleQuestion(index)}
      >
        <div className="faq-card__header">
          <p className="faq-card__question FS20FW500 F-600">{item.question}</p>
          <span className="faq-card__icon">
            {isOpen ? (
              <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="38" height="38" rx="19" fill="rgba(127, 86, 217, 0.08)" />
                <path d="M12 19H26" stroke="#7F56D9" strokeWidth="3.17" strokeLinecap="round" />
              </svg>
            ) : (
              <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="38" height="38" rx="19" fill="rgba(127, 86, 217, 0.08)" />
                <path d="M12 19H26" stroke="#7F56D9" strokeWidth="3.17" strokeLinecap="round" />
                <path d="M19 12V26" stroke="#7F56D9" strokeWidth="3.17" strokeLinecap="round" />
              </svg>
            )}
          </span>
        </div>
        {isOpen && (
          <div className="faq-card__answer">
            <p className="quote-para FS16FW500">{item.answer}</p>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="custom-container">
      {/* faq-new-section */}
      <h2 className="faq-new-section__title FS40FW600 mb-4">
        {title || <>Frequently Asked <span className="green-text">Questions</span></>}
      </h2>
      <div className="faq-new-section__grid">
        <div className="faq-new-section__col">
          {leftQuestions.map((item, i) => renderItem(item, i))}
        </div>
        <div className="faq-new-section__col">
          {rightQuestions.map((item, i) => renderItem(item, i + half))}
        </div>
      </div>
    </div>
  );
};

export default FaqSection;
